import React from 'react'
import * as colors from 'material-ui/styles/colors';

const styleLabelArea = {
  fontSize: '16px',
  lineHeight: '24px',
  width: '200px',
  height: '72px',
  display: 'inline-block',
  position: 'relative',
  backgroundColor: 'transparent',
  fontFamily: 'Roboto, sans-serif',
  transition: 'height 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  cursor: 'not-allowed',
}


const styleTitle = {
  position: 'absolute',
  lineHeight: '22px',
  top: '38px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  zIndex: '1',
  transform: 'scale(0.75) translate(0px, -28px)',
  transformOrigin: 'left top 0px',
  pointerEvents: 'none',
  userSelect: 'none',
  color: colors.grey600,
}

const styleValue = {
  padding: '0px',
  position: 'relative',
  width: '100%',
  border: 'none',
  outline: 'none',
  backgroundColor: 'rgba(0, 0, 0, 0)',
  color: colors.grey800,
  cursor: 'inherit',
  fontStyle: 'inherit',
  fontVariant: 'inherit',
  fontWeight: 'inherit',
  fontStretch: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  fontFamily: 'inherit',
  height: '100%',
  boxSizing: 'border-box',
  marginTop: '37px'
}

const FormLabel = ({ name, title, value, style}) => {
  return (
    <div style={styleLabelArea}>
      <span style={styleTitle}>{title}</span>
      <div style={{...styleValue, ...style}} >{value}</div>
    </div>
  )
}

export default FormLabel


// WEBPACK FOOTER //
// ./src/components/FormLabel.js